// Importamos los hooks y funciones necesarias desde React
import React, { createContext, useState, useContext } from "react";
// Definimos el tipo de datos que tendrá el contexto de autenticación
type AuthContextType = {
  isAuthenticated: boolean; // Indica si el usuario está autenticadoç
  hasCredentials?: boolean; // Indica si el usuario tiene credenciales
  login: () => void; // Función para iniciar sesión
  logout: () => void; // Función para cerrar sesión
};
// Creamos el contexto con valores por defecto
const AuthContext = createContext<AuthContextType>({
  isAuthenticated: false, // Por defecto no está autenticado
  hasCredentials: false, // Por defecto no tiene credenciales
  login: () => {}, // Función vacía como placeholder
  logout: () => {}, // Función vacía como placeholder
});
// Hook personalizado para consumir el contexto más fácilmente
export const useAuth = () => useContext(AuthContext);
// Componente proveedor del contexto de autenticación
export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  // Se inicializa leyendo del localStorage (persistencia).
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return localStorage.getItem("isAuthenticated") === "true";
  });
  const [hasCredentials, setHasCredentials] = useState(() => {
    return sessionStorage.getItem("authHeader") !== null;
  });
  // Función que se llama cuando el usuario inicia sesión
  const login = () => {
    setIsAuthenticated(true); // Cambiamos el estado a autenticado
    setHasCredentials(true); // Cambiamos el estado a tener credenciales
    localStorage.setItem("isAuthenticated", "true"); // Guardamos ese estado en localStorage
  };
  // Función que se llama cuando el usuario cierra sesión
  const logout = () => {
    setIsAuthenticated(false); // Cambiamos el estado a no autenticado
    setHasCredentials(false); // Cambiamos el estado a no tener credenciales
    localStorage.removeItem("isAuthenticated");
    sessionStorage.removeItem("authHeader"); // Eliminamos ese dato del localStorage
  };
  // Proveemos el contexto con los valores reales de autenticación
  return (
    <AuthContext.Provider
      value={{ isAuthenticated, hasCredentials, login, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};
